import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './ConstituencyWrapper.scss';
import ConstituencyCandidate from '../ConstituencyCandidate';
import ConstituencyWidget from '../ConstituencyWidget/ConstituencyWidget';
import Link from '../../../components/Link/Link';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import { loadLatestYearTopCandidateData } from '../../../routes/newslisting/redux';

class ConstituencyShowWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    const data = this.props?.sectionItem;
    const { electionData } = data?.dataMapping;
    try {
      if (electionData) {
        const liveData = Object.values(electionData).filter(
          d => d.live === true,
        );
        if (liveData && Array.isArray(liveData) && liveData.length) {
          const [{ source }] = liveData || [{ source: '' }];
          this.state.source = source;
        }
      }
    } catch (error) {
      //
    }
  }

  componentDidMount() {
    const data = this.props.sectionItem;
    const { electionData } = data.dataMapping;
    if (electionData) {
      const liveData = Object.values(electionData).filter(d => d.live === true);
      if (liveData && Array.isArray(liveData) && liveData.length) {
        const [{ url }] = liveData || [{ url: '' }];
        if (url) {
          setInterval(() => {
            this.props.loadAjaxLatestYearData(url, data.constituency, 5);
          }, 30 * 1000);
        }
      }
    }
  }

  render() {
    const { latestYearData, sectionItem } = this.props;
    const { electionData } = sectionItem.dataMapping;
    const { items, cnsID } = sectionItem;
    return (
      <div className={`${s.constituencyWrap}`}>
        <div className="ConstituencyShow">
          {electionData[latestYearData?.year] &&
            electionData[latestYearData?.year]?.note &&
            electionData[latestYearData?.year]?.noteCnsIds &&
            electionData[latestYearData?.year]?.noteCnsIds.includes(cnsID) && (
              <p className={s.noteText}>
                {electionData[latestYearData?.year]?.note}
              </p>
            )}
          {latestYearData?.top_candidates &&
            Array.isArray(latestYearData?.top_candidates) &&
            latestYearData?.top_candidates.length && (
              <ConstituencyWidget
                showStatus
                title={`${latestYearData.year} ${
                  this.props.loksabha
                    ? `${latestYearData?.name || ''} Lok Sabha`
                    : `${latestYearData?.name || ''} Assembly`
                } Election Results`}
                toBeDecided={
                  latestYearData.top_candidates[0].cs === 2 ||
                  latestYearData.top_candidates[0].cs === 1 ||
                  latestYearData.top_candidates[0].cs === 0
                }
              >
                {latestYearData.top_candidates &&
                  Array.isArray(latestYearData.top_candidates) &&
                  latestYearData.top_candidates.length &&
                  latestYearData.top_candidates.map((candidate, index1) => (
                    <ConstituencyCandidate
                      candidate={candidate}
                      index={index1}
                      isWapView={this.props.isWapView}
                      vm={latestYearData?.vm}
                      candidateLinking={
                        electionData[latestYearData?.year]?.candidateLinking
                      }
                    />
                  ))}
              </ConstituencyWidget>
            )}
          {this.state?.source && (
            <div className={`${s.source} ${s.cs}`}>
              Source: {this.state?.source}
            </div>
          )}
          {items &&
            Array.isArray(items) &&
            items.length &&
            items.map(
              (item, index) =>
                index > 0 &&
                item?.top_candidates &&
                Array.isArray(item.top_candidates) &&
                item.top_candidates.length && (
                  <>
                    {electionData[item?.year] &&
                      electionData[item?.year]?.note &&
                      electionData[item?.year]?.noteCnsIds &&
                      electionData[item?.year]?.noteCnsIds.includes(cnsID)(
                        <p className={s.noteText}>
                          {electionData[item?.year]?.note}
                        </p>,
                      )}
                    <ConstituencyWidget
                      showStatus
                      title={`${item.year} ${
                        this.props.loksabha
                          ? `${item?.name || ''} Lok Sabha`
                          : `${item?.name || ''} Assembly`
                      } Election Results`}
                      toBeDecided={
                        item.top_candidates[0].cs === 2 ||
                        item.top_candidates[0].cs === 1 ||
                        item.top_candidates[0].cs === 0
                      }
                    >
                      {item?.top_candidates &&
                        Array.isArray(item.top_candidates) &&
                        item.top_candidates.length &&
                        item.top_candidates.map((candidate, index1) => (
                          <ConstituencyCandidate
                            candidate={candidate}
                            index={index1}
                            isWapView={this.props.isWapView}
                            vm={item?.vm}
                          />
                        ))}
                    </ConstituencyWidget>
                  </>
                ),
            )}
        </div>
        {sectionItem?.stateConstituencies &&
          Array.isArray(sectionItem.stateConstituencies) &&
          sectionItem.stateConstituencies.length && (
            <div className={s.footerTop}>
              <Listingheader
                headingname={`${sectionItem?.stateName} Constituencies`}
                headingLink={sectionItem?.path}
                // newga={`${sectionData.name}Section_Actions#HeadingClick`}
                // target={sectionData.target === '_blank' ? sectionData.target : ''}
                // ga4Type={ga4Type}
                // ga4Category={ga4Category}
              >
                <Link to={sectionItem?.path} className={s.seeAllBtn}>
                  See All
                </Link>
              </Listingheader>
              <ul className={s.btmLink}>
                {sectionItem.stateConstituencies.map(data => (
                  <li>
                    <Link to={data.wu} doNotChangeDomain>
                      {data.hl}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
      </div>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxLatestYearData: (url, constituency, number) => {
    dispatch(loadLatestYearTopCandidateData(url, constituency, number));
  },
});

const mapStateToProps = state => ({
  latestYearData: state.newslisting && state.newslisting?.latestYearData,
  loksabha: state.newslisting && state.newslisting?.loksabha,
});

ConstituencyShowWrapper.propTypes = {
  latestYearData: PropTypes.objectOf({}),
  loksabha: PropTypes.bool,
};
ConstituencyShowWrapper.defaultProps = {
  latestYearData: {},
  loksabha: false,
};

export default connect(mapStateToProps, mapDispatchtoProps)(
  ConstituencyShowWrapper,
);
